import { userAgentCheck } from './UserAgentCheck';

const popup = () => {
  const popupCloseButton = document.getElementById('js-help-close-button');
  const helpButton = document.getElementsByClassName('js-help-button');
  const popupBody = document.getElementById('js-help');
  const popupInner = document.getElementById('js-help-inner');
  const siteBody = document.querySelector<HTMLBodyElement>('html body')!;

  const msM = 300;
  let flag = false;
  let scrollY: number;
  if (popupBody && popupInner) {
    popupBody.style.display = 'none';
    popupBody.style.opacity = '0';
    siteBody.style.cssText = 'width: auto; position:static;';

    const invisibleFunc = () => {
      if (flag) {
        flag = false;
        const positionY = Number(siteBody.dataset.position);
        popupBody.style.transition = 'opacity ' + msM + 'ms';
        popupBody.style.opacity = '0';
        siteBody.dataset.position = '0';
        const displayFunc = () => {
          //非表示にする関数を定義
          popupBody.style.display = 'none';
        };
        setTimeout(displayFunc, msM); //読み込み後、２秒後に非表示
        siteBody.style.width = 'auto';
        siteBody.style.position = 'static';
        window.scrollTo(0, positionY * -1);
      }
    };
    const visibleFunc = () => {
      if (!flag) {
        flag = true;
        popupBody.style.transition = 'opacity ' + msM + 'ms';
        popupBody.style.display = 'block';
        const browser = window.navigator.userAgent.toLowerCase();
        if ('scrollingElement' in document) {
          scrollY = document.scrollingElement!.scrollTop;
        } else if (browser.indexOf('webkit') > 0) {
          scrollY = parseInt(document.body.style.top || '0', 10);
        } else {
          scrollY = parseInt(document.body.style.top || '0', 10);
        }
        siteBody.dataset.position = `${scrollY * -1}`;
        const opacityFunc = () => {
          //非表示にする関数を定義
          popupBody.style.opacity = '1';
        };

        setTimeout(opacityFunc, 0); //読み込み後、２秒後に非表示
        siteBody.style.width = '100%';
        siteBody.style.position = 'fixed';
        // siteBody.style.top = `${scrollY * -1}px`;
        siteBody.style.setProperty('top', `${scrollY * -1}px`, 'important');
      }
    };
    const maskInvisibleFunc = (e: Event) => {
      const judgeTarget = document.querySelector('.js-help-button > img');
      if (flag) {
        const clickTarget = e.target! as HTMLElement;
        if (judgeTarget === clickTarget) return false;
        if (!clickTarget.closest('#js-help-inner')) {
          invisibleFunc();
        } else {
          return false;
        }
      }
    };
    if (!userAgentCheck.Mobile) document.addEventListener('click', maskInvisibleFunc);
    if (popupCloseButton) popupCloseButton.addEventListener('click', invisibleFunc);
    if (helpButton.length > 0) {
      for (let i = 0; i < helpButton.length; i = (i + 1) | 0) {
        helpButton[i].addEventListener('click', visibleFunc);
      }
    }
  }
};
export { popup };
